<button type="button">
    <ng-content></ng-content>
</button>
